import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QuillRemoveButtonsDirective } from './quill-remove-buttons/quill-remove-buttons.directive';
import { PreventDoubleClickDirective } from './prevent-double-click/prevent-double-click.directive';



@NgModule({
  declarations: [
    QuillRemoveButtonsDirective,
    PreventDoubleClickDirective,
  ],
  imports: [
    CommonModule
  ],
  exports: [
    QuillRemoveButtonsDirective,
    PreventDoubleClickDirective,
  ]
})
export class DirectivesModule { }
